
    import './styles.scoped.css';
    export default {
  "tab-dismiss-button": "awsui_tab-dismiss-button_1nq1i_1nd7r_5"
};
  